export default {
  scales: [],
  employees_scales: [],
  scales_types: [],
  swaps: [],
}
